import { render, staticRenderFns } from "./SingleTaskView.vue?vue&type=template&id=4679f1e8&scoped=true&"
import script from "./SingleTaskView.vue?vue&type=script&lang=js&"
export * from "./SingleTaskView.vue?vue&type=script&lang=js&"
import style0 from "./SingleTaskView.vue?vue&type=style&index=0&id=4679f1e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4679f1e8",
  null
  
)

export default component.exports